import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { getToolsByCategory } from "@/lib/toolsData";

const Tools = () => {
  const categorizedTools = getToolsByCategory();

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Free Marketing Tools",
    "description": "Professional marketing calculators and utilities to optimize campaigns, measure performance, and drive growth.",
    "url": "https://xperfomax.com/tools",
    "provider": {
      "@type": "Organization",
      "name": "XperfoMax",
      "url": "https://xperfomax.com"
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Free Marketing Tools"
        description="Professional marketing calculators and utilities to optimize campaigns, measure performance, and drive growth. ROI, ROAS, CTR, CPA calculators and more."
        canonicalUrl="https://xperfomax.com/tools"
        schema={schema}
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              Free Marketing Tools
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Professional calculators and utilities to optimize your marketing campaigns and measure performance.
            </p>
          </div>

          {/* Categories */}
          {categorizedTools.map((category) => (
            <section key={category.category} className="mb-16">
              <div className="mb-6">
                <h2 className="text-2xl font-semibold text-foreground">
                  {category.title}
                </h2>
                <p className="text-muted-foreground text-sm mt-1">
                  {category.description}
                </p>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {category.tools.map((tool) => (
                  <Link key={tool.href} to={tool.href}>
                    <Card className="h-full hover:shadow-md transition-all cursor-pointer border-border hover:border-primary/40 group">
                      <CardHeader className="pb-3">
                        <div className="flex items-start justify-between">
                          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                            <tool.icon className="w-5 h-5 text-primary" />
                          </div>
                          <ArrowRight className="w-4 h-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
                        </div>
                        <CardTitle className="text-base">{tool.title}</CardTitle>
                        <CardDescription className="text-sm">
                          {tool.description}
                        </CardDescription>
                      </CardHeader>
                    </Card>
                  </Link>
                ))}
              </div>
            </section>
          ))}

          {/* Bottom CTA */}
          <section className="border-t border-border pt-12 text-center">
            <p className="text-muted-foreground mb-4">
              Need help interpreting these metrics for your business?
            </p>
            <Link 
              to="/contact" 
              className="text-primary hover:text-primary/80 font-medium inline-flex items-center gap-2"
            >
              Talk to the XperfoMax team
              <ArrowRight className="w-4 h-4" />
            </Link>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Tools;
